import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';

export function safeHref(value) {
  if (typeof value !== 'string' || /\s/.test(value) || value.includes('\\')) return '/concierge';
  if (/^\/(?!\/)/.test(value) && !value.includes('\\')) return value;
  try { const u = new URL(value); if (u.protocol === 'https:' && !u.username && !u.password) return value; } catch { /* Invalid CMS URL. */ }
  return '/concierge';
}

export default function EditorialLink({ to, children, className = '', ...props }) {
  const href = safeHref(to);
  const contents = <>{children}<FiArrowRight aria-hidden="true" /></>;
  return href.startsWith('/') ? <Link to={href} className={`hlt-link ${className}`} {...props}>{contents}</Link>
    : <a href={href} className={`hlt-link ${className}`} target="_blank" rel="noopener noreferrer" {...props}>{contents}</a>;
}
